// extracted by mini-css-extract-plugin
module.exports = {"sfdcModalContainer":"salesforce-add-email_sfdcModalContainer_jk_","emailInput":"salesforce-add-email_emailInput_3jm","emptyIcon":"salesforce-add-email_emptyIcon_1eE"};